import './JobStatusBadge.scss';
import { useTranslator } from '@Localization';
import classNames from 'classnames';
import { ReactElement } from 'react';
import { StatusBadge } from '../../../../design/statusBadge/StatusBadge';
import { JOB_STATUS } from '../../../jobs/jobs.model';
import { StatusFailureIcon } from '../StatusFailureIcon';

interface IJobStatusBadgeProps {
  jobStatus: JOB_STATUS;
  failureReason?: string;
}

export const JobStatusBadge = ({ failureReason, jobStatus }: IJobStatusBadgeProps): ReactElement => {
  const { t } = useTranslator();
  const getText = (): string => {
    switch (jobStatus) {
      case JOB_STATUS.DRAFT:
        return t('job_status.draft');
      case JOB_STATUS.EVALUATING:
        return t('job_status.evaluating');
      case JOB_STATUS.FAILED:
        return t('job_status.failed');
      case JOB_STATUS.FAILING:
        return t('job_status.failing');
      case JOB_STATUS.FINISHED:
        return t('job_status.finished');
      case JOB_STATUS.FINISHING:
        return t('job_status.finishing');
      case JOB_STATUS.IMPORTED:
        return t('job_status.imported');
      case JOB_STATUS.IMPORTING:
        return t('job_status.importing');
      case JOB_STATUS.RETRYING:
        return t('job_status.retrying');
      case JOB_STATUS.RUNNING:
        return t('job_status.running');
      case JOB_STATUS.STARTING:
        return t('job_status.starting');
      case JOB_STATUS.STOPPED:
        return t('job_status.stopped');
      case JOB_STATUS.STOPPING:
        return t('job_status.stopping');
      case JOB_STATUS.SAVING:
        return t('job_status.saving');
      case JOB_STATUS.WAITING:
        return t('job_status.waiting');
      case JOB_STATUS.UNKNOWN:
      default:
        return t('job_status.unknown');
    }
  };

  return (
    <StatusBadge
      customStartDecorator={failureReason ? <StatusFailureIcon /> : undefined}
      className={classNames('job-status-badge', jobStatus.toLowerCase())}
      text={getText()}
      title={failureReason}
    />
  );
};
